import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";

import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Checkbox from "@material-ui/core/Checkbox";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError"; 
import { AuthContext } from "../../context/Auth/AuthContext";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import { Typography } from "@mui/material";
import { FormControlLabel, Switch } from "@material-ui/core";

// Componente TabPanel
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={0}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const useStyles = makeStyles(theme => ({
  contactsWrapper: {
    display: "flex",
    height: "100%",
  },
  mainWrapper: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1),
    height: "100%",
    overflow: "hidden",
    borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
  },
  contactsHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1),
  },
  contactsSearchBox: {
    flex: 1,
    marginLeft: theme.spacing(1),
  },
  contactsList: {
    flex: 1,
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  contactsListItem: {
    paddingTop: "4px",
    paddingBottom: "4px",
    "& .MuiListItemSecondaryAction-root": {
      right: "5px",
    },
  },
  contactNameWrapper: {
    display: "flex",
    flexDirection: "column",
    marginLeft: theme.spacing(1.5),
  },
  contactLastMessage: {
    marginTop: "4px",
    marginLeft: "5px",
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "12px",
  },
  newMessagesCount: {
    alignSelf: "center",
    marginRight: theme.spacing(1),
    marginLeft: "auto",
  },
  badgeStyle: {
    color: "white",
    backgroundColor: green[500],
  },
  onlineStatus: {
    display: "flex",
    alignItems: "center",
    marginLeft: "5px",
  },
  onlineBadge: {
    width: "13px",
    height: "13px",
    borderRadius: "50%",
    backgroundColor: "#44b700",
    marginRight: "3px",
  },
  offlineBadge: {
    width: "13px",
    height: "13px",
    borderRadius: "50%",
    backgroundColor: "#ccc",
    marginRight: "3px",
  },
  tabsContainer: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    marginBottom: theme.spacing(2),
  },
  tabPanel: {
    padding: 0,
  },
  searchField: {
    marginBottom: theme.spacing(2),
  }
}));

const ForwardMessageModal = ({ messages, onClose, modalOpen }) => {
    const classes = useStyles();
    const { user } = useContext(AuthContext);
    const { setIsSelectionMode, setShowSelectMessageCheckbox, setSelectedMessages } = useContext(ForwardMessageContext);
    const [sending, setSending] = useState(false);
    const [messageSending, setMessageSending] = useState('');
    const [signMessage, setSignMessage] = useState(true);
    const [openTickets, setOpenTickets] = useState([]);
    const [selectedTickets, setSelectedTickets] = useState([]);
    const [loadingTickets, setLoadingTickets] = useState(false);
    
    // Estados para as abas
    const [activeTab, setActiveTab] = useState(0);
    
    // Estados para busca de contatos
    const [contacts, setContacts] = useState([]);
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [loadingContacts, setLoadingContacts] = useState(false);
    const [searchParam, setSearchParam] = useState('');

    // Função para buscar contatos
    const fetchContacts = async (searchParam = '') => {
        setLoadingContacts(true);
        try {
            const { data } = await api.get("/contacts/", {
                params: { 
                    searchParam, 
                    pageNumber: 1,
                    limit: 50 // Limitar para não sobrecarregar
                },
            });
            setContacts(data.contacts || []);
        } catch (err) {
            console.error("Erro ao buscar contatos:", err);
            toastError(err);
        }
        setLoadingContacts(false);
    };

    useEffect(() => {
        if (!modalOpen) return;

        const fetchOpenTickets = async () => {
            setLoadingTickets(true);
            try {
                console.log("Buscando tickets com userId:", user.id);
                console.log("Filas do usuário:", user.queues);
                
                // Obter as filas do usuário
                const userQueueIds = user.queues ? user.queues.map(queue => queue.id) : [];
                console.log("IDs das filas:", userQueueIds);
                
                // Usar exatamente a mesma requisição que funciona na aba "atendendo"
                const { data } = await api.get("/tickets", {
                    params: {
                        status: "open",
                        pageNumber: "1",
                        queueIds: JSON.stringify(userQueueIds),
                        showAll: "false",
                        sortTickets: "DESC"
                    },
                });
                console.log("Tickets encontrados:", data);
                setOpenTickets(data.tickets || []);
            } catch (err) {
                console.error("Erro ao buscar tickets:", err);
                toastError(err);
            }
            setLoadingTickets(false);
        };

        fetchOpenTickets();
        
        // Buscar contatos iniciais quando a modal abrir
        if (activeTab === 1) {
            fetchContacts();
        }
    }, [modalOpen, user.id, activeTab]);


	const history = useHistory();

	const sleep = (ms) => {
		return new Promise(resolve => setTimeout(resolve, ms));
	};

    const handleForwardMessage = async() => {
        const totalSelected = selectedTickets.length + selectedContacts.length;
        if (totalSelected === 0) return;

        setSending(true);
        
        // Combinar tickets e contatos selecionados
        const ticketTargets = selectedTickets.map(t => ({ id: t.contactId, type: 'ticket' }));
        const contactTargets = selectedContacts.map(c => ({ id: c.id, type: 'contact' }));
        const allTargets = [...ticketTargets, ...contactTargets];

        for (const message of messages) {
            for (const target of allTargets) {
                try {
                    setMessageSending(`${message.id} para ${target.id}`);
                    await api.post('/message/forward', {
                        messageId: message.id,
                        contactId: target.id,
                        signMessage: signMessage
                    });
                    await sleep(900);
                } catch (error) {
                    toastError(error);
                }
            }
        }
        setSending(false);
        
        // Desativar o modo de seleção após o encaminhamento
        setIsSelectionMode(false);
        setShowSelectMessageCheckbox(false);
        setSelectedMessages([]);
        
        onClose();
    }

    const handleSelectTicket = (ticket) => {
        const ticketIndex = selectedTickets.findIndex(t => t.id === ticket.id);
        if (ticketIndex !== -1) {
            setSelectedTickets(selectedTickets.filter(t => t.id !== ticket.id));
        } else {
            setSelectedTickets([...selectedTickets, ticket]);
        }
    };

    const handleSelectContact = (contact) => {
        const contactIndex = selectedContacts.findIndex(c => c.id === contact.id);
        if (contactIndex !== -1) {
            setSelectedContacts(selectedContacts.filter(c => c.id !== contact.id));
        } else {
            setSelectedContacts([...selectedContacts, contact]);
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 1 && contacts.length === 0) {
            fetchContacts();
        }
    };

    const handleSearchChange = (event) => {
        setSearchParam(event.target.value);
    };

    // Debounce da busca
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (activeTab === 1) {
                fetchContacts(searchParam);
            }
        }, 500);
        
        return () => clearTimeout(timeoutId);
    }, [searchParam, activeTab]);

    const handleClose = () => {
		onClose();
		setSending(false);
		setActiveTab(0);
		setSelectedContacts([]);
		setSearchParam('');
	};

    return (
        <>
			<Dialog 
				open={modalOpen} 
				onClose={handleClose}
				maxWidth="sm"
				fullWidth
			>
				<DialogTitle id="form-dialog-title" style={{ padding: '16px 20px 8px 20px', fontSize: '18px', fontWeight: '500' }}>
					Encaminhar {messages.length > 1 ? `${messages.length} mensagens` : 'mensagem'}
				</DialogTitle>
				<DialogContent style={{ padding: '0 20px' }}>
					{messages.length > 1 && (
						<div style={{ 
							marginBottom: '12px', 
							padding: '8px 12px', 
							backgroundColor: '#e3f2fd', 
							borderRadius: '6px',
							border: '1px solid #bbdefb'
						}}>
							<Typography variant="body2" color="primary" style={{ fontSize: '13px', fontWeight: '500' }}>
								{messages.length} mensagens selecionadas
							</Typography>
						</div>
					)}
					
					{/* Abas */}
					<div className={classes.tabsContainer}>
						<Tabs 
							value={activeTab} 
							onChange={handleTabChange} 
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
						>
							<Tab label="Conversas em Atendimento" />
							<Tab label="Pesquisar Contatos" />
						</Tabs>
					</div>

					{/* Aba 1: Conversas em Atendimento */}
					<TabPanel value={activeTab} index={0}>
						<List style={{ minHeight: '200px', maxHeight: '200px', overflowY: 'auto' }}>
							{loadingTickets ? (
								<div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
									<CircularProgress size={24} />
								</div>
							) : openTickets.length === 0 ? (
								<div style={{ 
									display: 'flex', 
									justifyContent: 'center', 
									alignItems: 'center', 
									height: '200px',
									flexDirection: 'column',
									color: '#666'
								}}>
									<Typography variant="body2" color="textSecondary">
										Nenhuma conversa em atendimento encontrada
									</Typography>
									<Typography variant="caption" color="textSecondary" style={{ marginTop: '8px' }}>
										Total de tickets: {openTickets.length}
									</Typography>
								</div>
							) : (
								openTickets.map(ticket => {
									const isSelected = selectedTickets.some(t => t.id === ticket.id);
									return (
										<ListItem
											key={ticket.id}
											button
											onClick={() => handleSelectTicket(ticket)}
											className={classes.contactsListItem}
										>
											<Avatar 
									src={ticket.contact?.profilePicUrl} 
									alt="contact_image"
									style={{ width: 35, height: 35 }}
								>
									{!ticket.contact?.profilePicUrl && <WhatsAppIcon />}
											</Avatar>
											<ListItemText
												primary={
													<div className={classes.contactNameWrapper}>
														<Typography noWrap style={{ fontWeight: 500 }}>
															{ticket.contact?.name || 'Nome não disponível'}
														</Typography>
														<Typography variant="caption" color="textSecondary" noWrap>
															{ticket.lastMessage?.length > 40 
																? ticket.lastMessage.slice(0, 40) + "..."
																: ticket.lastMessage || 'Sem mensagens'}
														</Typography>
													</div>
												}
											/>
											<ListItemSecondaryAction>
												<Checkbox
													edge="end"
													checked={isSelected}
													onChange={() => handleSelectTicket(ticket)}
												/>
											</ListItemSecondaryAction>
										</ListItem>
									);
								})
							)}
						</List>
					</TabPanel>

					{/* Aba 2: Pesquisar Contatos */}
					<TabPanel value={activeTab} index={1}>
						<TextField
							fullWidth
							variant="outlined"
							placeholder="Digite o nome ou número do contato..."
							value={searchParam}
							onChange={handleSearchChange}
							className={classes.searchField}
							size="small"
						/>
						
						<List style={{ minHeight: '200px', maxHeight: '200px', overflowY: 'auto' }}>
							{loadingContacts ? (
								<div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
									<CircularProgress size={24} />
								</div>
							) : contacts.length === 0 ? (
								<div style={{ 
									display: 'flex', 
									justifyContent: 'center', 
									alignItems: 'center', 
									height: '200px',
									flexDirection: 'column',
									color: '#666'
								}}>
									<Typography variant="body2" color="textSecondary">
										{searchParam ? 'Nenhum contato encontrado' : 'Digite algo para buscar contatos'}
									</Typography>
									<Typography variant="caption" color="textSecondary" style={{ marginTop: '8px' }}>
										Total de contatos: {contacts.length}
									</Typography>
								</div>
							) : (
								contacts.map(contact => {
									const isSelected = selectedContacts.some(c => c.id === contact.id);
									return (
										<ListItem
											key={contact.id}
											button
											onClick={() => handleSelectContact(contact)}
											className={classes.contactsListItem}
										>
											<Avatar 
									src={contact.profilePicUrl} 
									alt="contact_image"
									style={{ width: 35, height: 35 }}
								>
									{!contact.profilePicUrl && <WhatsAppIcon />}
											</Avatar>
											<ListItemText
												primary={
													<div className={classes.contactNameWrapper}>
														<Typography noWrap style={{ fontWeight: 500 }}>
															{contact.name || 'Nome não disponível'}
														</Typography>
														<Typography variant="caption" color="textSecondary" noWrap>
															{contact.number || 'Número não disponível'}
														</Typography>
													</div>
												}
											/>
											<ListItemSecondaryAction>
												<Checkbox
													edge="end"
													checked={isSelected}
													onChange={() => handleSelectContact(contact)}
												/>
											</ListItemSecondaryAction>
										</ListItem>
									);
								})
							)}
						</List>
					</TabPanel>
				</DialogContent>
				<DialogActions style={{ padding: '16px 20px', justifyContent: 'space-between' }}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						{sending && (
							<div style={{ display: 'flex', alignItems: 'center', marginRight: '12px' }}>
								<CircularProgress color="inherit" size={16} style={{ marginRight: '6px' }} />
								<Typography variant="body2" color="textSecondary" style={{ fontSize: '12px' }}>
									Enviando...
								</Typography>
							</div>
						)}
						<FormControlLabel
							style={{ margin: 0, color: "gray" }}
							label={i18n.t("messagesInput.signMessage")}
							labelPlacement="start"
							control={
								<Switch
									size="small"
									checked={signMessage}
									onChange={(e) => {
										setSignMessage(e.target.checked);
									}}
									name="showAllTickets"
									color="primary"
								/>
							}
						/>
					</div>
					<ButtonWithSpinner
						variant="contained"
						type="button"
						disabled={(selectedTickets.length + selectedContacts.length) === 0 || sending}
						onClick={handleForwardMessage}
						color="primary"
						loading={sending}
						size="small"
						style={{ minWidth: '100px' }}
					>
						Encaminhar ({selectedTickets.length + selectedContacts.length})
					</ButtonWithSpinner>
				</DialogActions>
			</Dialog>
		</>
    );
};

export default ForwardMessageModal;